var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2758_2079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2758_2079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.90039 39.8V7.30002L14.6004 1.40002L23.3004 7.30002V14.4H42.1004V39.8H5.90039ZM7.30039 38.4H13.9004V31.8H7.30039V38.4ZM7.30039 30.4H13.9004V23.8H7.30039V30.4ZM7.30039 22.4H13.9004V15.8H7.30039V22.4ZM7.30039 14.4H13.9004V7.80002H7.30039V14.4ZM15.3004 14.4H21.9004V7.80002H15.3004V14.4ZM15.3004 38.4H40.7004V15.8H15.3004V38.4ZM28.3004 23.8V22.4H34.7004V23.8H28.3004ZM28.3004 31.8V30.4H34.7004V31.8H28.3004ZM21.9004 23.8V22.4H23.3004V23.8H21.9004ZM21.9004 31.8V30.4H23.3004V31.8H21.9004Z",
    fill: "#2D76FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceEnvironment);
export default __webpack_public_path__ + "static/media/source_environment.5af11a1663852d1ccc2cd9188244bb4a.svg";
export { ForwardRef as ReactComponent };